// extracted by mini-css-extract-plugin
export default {"newCode":"GenerateCodePanel_newCode__F4tYh","spinner":"GenerateCodePanel_spinner__irt0M"};